import { getImage, GatsbyImage } from 'gatsby-plugin-image';
import React from 'react';

function Doing({ title, gif, image })
{
  return (
    <div className="flex flex-col items-center justify-between py-8">
      <div className="relative w-52 h-32">
        <GatsbyImage image={getImage(image)} className="hover:opacity-0 z-10 h-full w-full object-cover" alt={title} />
        <img src={gif.url} className="absolute w-52 h-32 top-0 left-0 z-0 " alt={title} />
      </div>
      <h3 className="text-orange font-semibold text-4xl">{title}</h3>
    </div>
  )
}

function ContentDoing({ items })
{
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-8">
      {items.map((item) => (
        <Doing key={item.id} {...item.text.blocks[0]} />
      ))}
    </div>
  );
}

export default ContentDoing;